import { render, staticRenderFns } from "./Dsgvo.vue?vue&type=template&id=88766e28"
import script from "./Dsgvo.vue?vue&type=script&lang=js"
export * from "./Dsgvo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports